import http from "@/api";

export const listCustomerServices = (params?: any) => {
	return http.get<API.Response<API.ListResult<API.CustomerService>>>(`/basicData/customerServices/list`, params);
};
